import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { DEVICE_SENSOR_TREND } from './url-constants';


type SensorTrendDataEndpointSpecification = ApiEndpointSpecification;
export const SensorTrendDataEndpointSpecification: SensorTrendDataEndpointSpecification = {
    url:DEVICE_SENSOR_TREND,
    method:HttpMethod.POST,
    requestParamsSchemaName: 'SensorTrendDataRequestParams',
    requestBodySchemaName: 'SensorTrendDataRequestBody',
    okResponseSchemaName: 'SensorTrendDataOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
    version:2
};

export const invokeSensorTrendData = Helpers.makeApiRequestFn<
    Types.SensorTrendDataRequestParams,
    Types.SensorTrendDataRequestBody,
    Types.SensorTrendDataOkresponse
>(SensorTrendDataEndpointSpecification);
